import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {ordensServicoModuleName} from "../shared/data.service";
import {OrdemServico} from "../shared/ordem-servico.model";
import {UtilService} from "../../../shared/services/util.service";
import {OrdemServicoApiService} from "../shared/ordem-servico-api.service";
import {OrdemServicoService} from "../shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../shared/ordem-servico-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";

@Component({
    template: require('./ordem-servico-detail.component.html'),
    styles: [require('./ordem-servico-detail.component.css')]
})
export class OrdemServicoDetailComponent implements OnInit {
    ordensServicoModule: any = ordensServicoModuleName;
    detail: OrdemServico = new OrdemServico();
    statusObject: any = {};
    tipoObject: any = {};
    tabSelected: string = 'detalhes';
    total: number = 0;
    materiaisList: any[] = [];
    servicosList: any[] = [];
    totalServicos: number = 0;
    totalMateriais: number = 0;

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    constructor(
        private _ordemServicoApiService: OrdemServicoApiService,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _ordemServicoService: OrdemServicoService,
        private _route: ActivatedRoute,
        private _frotaService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getObject();
        this.getMateriaisServicos();
        this.testFrotaBackHistory();
    }

    clickEdit() {
        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencaoEdit(this.frotaRoute, this.detail.id);
        } else {
            this._ordemServicoNavigationService.goToEdit(this.detail.id);
        }
    }

    clickList() {
        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencao(this.frotaRoute);
        } else {
            this._ordemServicoNavigationService.goToList();
        }
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    clickCancel() {
        this.cancel();
    }

    clickComplete() {
        this.complete();
    }

    setTab(tab:string) {
        this.tabSelected = tab;
    }

    isTab(tab: string) {
        return (tab === this.tabSelected);
    }

    private getObject() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.detail = Response;
                this.setToModel();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        let id = +this._route.snapshot.params['id'];
        this._ordemServicoApiService.onGetById(id, onDone);
    }

    private cancel() {
        const onDone = (function(Resposta: any) {
            if (!Resposta.error) {
                this.statusObject = this._ordemServicoService.getStatusCancelado();
                swal("Sucesso!", "A manutenção foi cancelada com sucesso.", "success");
            } else {
                swal("Erro!", "Não foi possível cancelar a manutenção.", "error");
            }
        }.bind(this));

        swal({
                title: "Você deseja realmente cancelar esta manutenção?",
                text: "Os materias alocados para realizar esta manutenção serão devolvidos ao almoxarifado. Esta operação não poderá ser desfeita!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Cancelar",
                cancelButtonText: "Fechar",
                closeOnConfirm: false
            },
            function() {
                let statusCancelado: any = this._ordemServicoService.getStatusCancelado();
                let obj: any = {id: this.detail.id, status: statusCancelado.Key};
                this._ordemServicoApiService.onPut(obj, onDone);
            }.bind(this)
        );
    }

    private complete() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.statusObject = this._ordemServicoService.getStatusConcluido();
                swal("Sucesso!", "A manutenção foi concluída com sucesso.", "success");
            } else {
                swal("Erro!", "Não foi possível concluir a manutenção.", "error");
            }
        }.bind(this));

        swal({
                title: "Você deseja realmente concluir esta manutenção?",
                text: "Esta operação não poderá ser desfeita!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Concluir",
                cancelButtonText: "Fechar",
                closeOnConfirm: false
            },
            function() {
                if (this.detail.dataSaida && this.detail.laudo && this.detail.odometroHorimetroId) {
                    let statusConcluido: any = this._ordemServicoService.getStatusConcluido();
                    let obj: any = {id: this.detail.id, status: statusConcluido.Key};
                    this._ordemServicoApiService.onPut(obj, onDone);
                } else {
                    swal({
                            title: "Dados incompletos para concluir a manutenção",
                            text: "Para concluir a manutenção informe o laudo, a data de saída e o odômetro/horímetro!",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Informar dados",
                            cancelButtonText: "Fechar",
                            closeOnConfirm: false
                        },
                        function() {
                            swal.close();
                            this.clickEdit();
                        }.bind(this)
                    );
                }
            }.bind(this)
        );
    }

    private setToModel() {
        if (this.detail.status) {
            this.statusObject = this._ordemServicoService.getStatusOrdemServico(this.detail.status);
        }

        if (this.detail.tipo) {
            this.tipoObject = this._ordemServicoService.getTipoOrdemServico(this.detail.tipo);
        }
    }

    private getMateriaisServicos() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                var total: number = 0,
                    servicos: any[] = [],
                    materiais: any[] = [],
                    totalServicos: number = 0,
                    totalMateriais: number = 0,
                    tipoServico: any = this._ordemServicoService.getItemTipoServico();

                tipoServico = tipoServico.Key;
                Response.forEach(function(item: any) {
                    item.valorUnitario = (item.valor / item.quantidade).toFixed(2);
                    total += item.valor;

                    if (item.Tipo.Key === tipoServico) {
                        servicos.push(item);
                        totalServicos += item.valor;
                    } else {
                        materiais.push(item);
                        totalMateriais += item.valor;
                    }
                }.bind(this));

                this.materiaisList = materiais;
                this.servicosList = servicos;
                this.totalServicos = totalServicos;
                this.totalMateriais = totalMateriais;

                this.total = total;
            }
        }.bind(this));

        let id = +this._route.snapshot.params['id'];
        this._ordemServicoApiService.onGetByIdMateriaisServicos(id, onDone);
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory();

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-detail/ordem-servico-detail.component.ts
 **/